module.exports = __webpack_public_path__ + "static/media/invest_fund.82230646.svg";